export const emptyMark = {
  url: "",
  title: "",
  thumbnail: "",
  bgColor: "",
  color: "",
}

export const linkPage0Group0 = [
  {
    url: "https://naver.com/",
    title: "네이버",
    thumbnail:
      "https://user-images.githubusercontent.com/69343830/102716411-1c227700-431f-11eb-86e6-dd389b690681.png",
    bgColor: "",
    color: "",
  },
  {
    url: "https://www.google.com/",
    title: "구글",
    thumbnail: "https://cdn-icons-png.flaticon.com/128/300/300221.png",
    bgColor: "",
    color: "",
  },
]

export const linkPage0Group1 = [
  {
    url: "https://www.youtube.com/",
    title: "Youtube",
    thumbnail: "https://cdn-icons-png.flaticon.com/128/3938/3938026.png",
    bgColor: "",
    color: "",
  },
  {
    url: "https://drive.google.com/",
    title: "GDrive",
    thumbnail: "https://cdn-icons-png.flaticon.com/128/5968/5968523.png",
    bgColor: "",
    color: "",
  },
  {
    url: "https://mail.google.com/",
    title: "GMail",
    thumbnail: "https://cdn-icons-png.flaticon.com/128/5968/5968534.png",
    bgColor: "",
    color: "",
  },
]

export const linkPage0Group2 = []

export const linkPage0Group3 = []

export const linkPage1Group0 = [
  {
    url: "https://slack.com/intl/ko-kr/",
    title: "slack",
    thumbnail: "https://cdn-icons-png.flaticon.com/128/2111/2111615.png",
    bgColor: "",
    color: "",
  },
  {
    url: "https://discord.com/",
    title: "Discord",
    thumbnail: "https://cdn-icons-png.flaticon.com/128/5968/5968756.png",
    bgColor: "",
    color: "",
  },
]

export const linkPage1Group1 = [
  {
    url: "https://www.notion.so/",
    title: "Notion",
    thumbnail:
      "https://static.vecteezy.com/system/resources/thumbnails/007/910/756/small_2x/notion-app-logo-project-management-and-note-taking-software-vector.jpg",
    bgColor: "",
    color: "",
  },
  {
    url: "https://workflowy.com/",
    title: "Workflowy",
    thumbnail:
      "https://play-lh.googleusercontent.com/c7cl-3wGY1RyqbKxaTp07clI5rnO-vjIZcEmVNDYKu_VkCK1-SunawYyYM19b2k9N0ce",
    bgColor: "",
    color: "",
  },
]

export const linkPage1Group2 = []

export const linkPage1Group3 = []
